import $ from "jquery";
import Isotope from "isotope-layout";
import Siema from "siema";
(function ($) {
    if (buildings === void 0) {
        var buildings = {};
    }
    var svgModified = { c: false, d: false };
    var currentBuilding = "c";
    var iso = null;
    function populateIso(data, grid) {
        $("#properties").html("");
        var dataLength = data.length;
        var $items;
        $.each(data, function (k, v) {
            if (svgModified[currentBuilding] == false && v.is_sold_raw == 1) {
                var elm = $("#" + v.id);
                elm.addClass("sold");
                elm.children("pattern").attr("xlink:href", "#sold");
            }
            var $item = $('<div />', {
                'class': v.className + " item"
            });
            $item.append("\n                <div class=\"cell name\">" + v.name + "</div>\n                <div class=\"cell floor\">" + v.floor + "</div>\n                <div class=\"cell surface\">" + v.surface + "</div>\n                <div class=\"cell bedrooms\">" + v.bedrooms + "</div>\n                <div class=\"cell bathrooms\">" + v.bathrooms + "</div>\n                <div class=\"cell terrace\">" + v.terrace + "</div>\n                <div class=\"cell is_sold\">" + v.is_sold + "</div>\n                <div class=\"cell plan\">&nbsp;</div>\n            ");
            $items = $items ? $items.add($item) : $item;
            if (k == dataLength - 1) {
                svgModified[currentBuilding] = true;
                $("#properties").append($items);
                if (iso != null)
                    iso.destroy();
                iso = new Isotope(grid, {
                    itemSelector: '.item'
                });
                iso.layout();
            }
        });
    }
    function loadData(grid, type) {
        $.getJSON("/json/properties/" + type, function (data) {
            buildings[type] = data;
            populateIso(data, grid);
        });
    }
    function displayData(grid, building) {
        if (buildings[building] !== void 0) {
            populateIso(buildings[building], grid);
        }
        else {
            loadData(grid, building);
        }
    }
    $(document).ready(function () {
        if ($('.page-template-tpl-availability').length) {
            var grid = document.querySelector('#properties');
            //
            displayData(grid, "c");
            //
            var buildingTab_1 = new Siema({
                selector: '#buildings',
                duration: 300,
                easing: 'ease-out',
                perPage: 1,
                startIndex: 0,
                draggable: false,
                multipleDrag: false,
                threshold: 20,
                loop: false,
                rtl: false
            });
            $("#buildings-tab").on("click", "a", function (e) {
                e.preventDefault();
                var building = $(e.currentTarget).data("building");
                currentBuilding = building;
                $("#buildings-tab .current").removeClass("current");
                var parent = $(e.currentTarget).parent();
                parent.addClass("current");
                buildingTab_1.goTo(parent.index());
                displayData(grid, building);
                $("#cards").attr("data-building", currentBuilding);
                $('.ButtonWrapper').find(".Button").trigger("click");
            });
            // filter with selects and checkboxes
            var $selects = $('#filters select');
            var $checkboxes = $('#filters input');
            $selects.on("change", function (e) {
            });
            $('.remove').on("click", function (e) {
                $(e.currentTarget).next("select").val("").change();
                $(e.currentTarget).hide();
            });
            $('.ButtonWrapper').on("click", ".Button", function (e) {
                $selects.val("").change();
                $('#filters .remove').hide();
            });
            $selects.add($checkboxes).change(function (e) {
                if ($(e.currentTarget).val() == "") {
                    $(e.currentTarget).parent().find(".remove").hide();
                }
                else {
                    $(e.currentTarget).parent().find(".remove").show();
                }
                // map input values to an array
                var exclusives = [];
                var inclusives = [];
                // exclusive filters from selects
                $selects.each(function (i, elem) {
                    if (elem.value) {
                        exclusives.push(elem.value);
                    }
                });
                // inclusive filters from checkboxes
                // $checkboxes.each( function( i, elem ) {
                //     // if checkbox, use value if checked
                //     if ( elem.checked ) {
                //         inclusives.push( elem.value );
                //     }
                // });
                // first combine exclusives
                exclusives = exclusives.join('');
                var filterValue;
                if (inclusives.length) {
                    // map inclusives with exclusives for
                    filterValue = $.map(inclusives, function (value) {
                        return value + exclusives;
                    });
                    filterValue = filterValue.join(', ');
                }
                else {
                    filterValue = exclusives;
                }
                console.log(filterValue);
                iso.arrange({
                    filter: filterValue
                });
            });
            $("#buildings").on("click", "svg > g:not(.sold)", function (e) {
                var elm = $(e.currentTarget);
                var id = elm.attr("id");
                var card = $('.card[data-id=' + id + ']');
                $("#cards").fadeIn(400, function () {
                    card.fadeIn(200);
                });
                $(document).on("keydown", function (e) {
                    if (e.keyCode == 27) {
                        card.fadeOut(200, function () {
                            $("#cards").fadeOut(400, function () {
                                $("#cards").attr("style", "");
                            });
                        });
                    }
                });
                card.one("click", ".action a", function (e) {
                    e.preventDefault();
                    card.fadeOut(200, function () {
                        $("#cards").fadeOut(400, function () {
                            $("#cards").attr("style", "");
                        });
                    });
                });
            });
        }
    });
})($);
